export class EmailTemplateCategory {
	categoryName: string;
	emailTemplates: EmailTemplate[];
}

export class EmailTemplate {
	id: number;
	fullName: string;
	description: string;
	placeholders: string;

	subject: string;
	htmlBody: string;
	textBody: string;

	enabled: boolean;
	overridden: boolean;
	categoryId: number;
}

export class EmailTestSend {
	to: string;
	subject: string;
	htmlBody: string;
	textBody: string;
}
